import React from "react";
import "./Help.css";
import { useNavigate } from "react-router-dom";
import Dark_Blue_Btn from "../../../common_components/common_btn/dark_blue_btn/Dark_Blue_Btn";

const Help = () => {
  const navigate = useNavigate();

  return (
    <section className="help-section">
      <div className="help-banner-wrapper">
       
          <div className="help-overlay">
        <div className="container">
            <div className="help-content">
              <span className="help-tag">24/7 Support</span>

              <h2>
                We're Here To <span>Help You</span>
              </h2>

              <p>
               <b> Need assistance? </b>  Our support team is ready to answer your
                questions and provide quick solutions.
              </p>

              <div className="help-btn-group">
                <Dark_Blue_Btn
                  btn_name="Help Desk"
                  onClick={() => navigate("/help")}
                />

                <Dark_Blue_Btn
                  btn_name="Contact Us"
                  onClick={() => navigate("/contact")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Help;
